// Parses a plain CSS declaration string ("color:red; font-size:12px") into a
// React style object. Lets section components keep the design's original
// inline-style strings verbatim instead of hand-transcribing every property
// to camelCase JS.
const cache = new Map();

export function pstyle(str, extra) {
  if (!str) return extra;
  let obj = cache.get(str);
  if (!obj) {
    obj = {};
    for (const decl of str.split(";")) {
      const i = decl.indexOf(":");
      if (i < 0) continue;
      const prop = decl.slice(0, i).trim();
      const val = decl.slice(i + 1).trim();
      if (!prop || !val) continue;
      const key = prop.startsWith("--")
        ? prop
        : prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      obj[key] = val;
    }
    cache.set(str, obj);
  }
  return extra ? { ...obj, ...extra } : obj;
}
